import { render, staticRenderFns } from "./TeamProfileTab.vue?vue&type=template&id=60c96218&scoped=true"
import script from "./TeamProfileTab.vue?vue&type=script&lang=ts"
export * from "./TeamProfileTab.vue?vue&type=script&lang=ts"
import style0 from "./TeamProfileTab.vue?vue&type=style&index=0&id=60c96218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c96218",
  null
  
)

export default component.exports